import axios from "../plugins/axios.plugin";

class RevenueSettingsService {
  baseServicePath = "/api/revenue/setting";

  getAllRevenueSettings(page) {
    return axios.get(`${this.baseServicePath}/index?page=${page}&properties=1`);
  }

  getAllReferralsNoPagination(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}&properties=1`,
      payload,
    );
  }

  showARevenueSettings(id, type) {
    const idField = type === "shipper" ? "shipper_id" : "business_id";
    return axios.get(
      `${this.baseServicePath}/show?${idField}=${id}&type=${type}`,
    );
  }

  getMyReferrals() {
    return axios.get(`${this.baseServicePath}/me?properties=1`);
  }

  searchReferrals(payload) {
    return axios.post(`${this.baseServicePath}/search/index`, payload);
  }

  filterReferrals(payload, page) {
    return axios.post(
      `${this.baseServicePath}/filter/index?page=${page}&properties=1`,
      payload,
    );
  }

  editRevenueSettings(payload) {
    return axios.post(`${this.baseServicePath}/update`, payload);
  }

  storeRevenueSettings(payload) {
    return axios.post(`${this.baseServicePath}/store`, payload);
  }
}
export const revenueSettingsService = new RevenueSettingsService();
